export { InterfaceService } from '@app/interfaces/interface.service';
export { InterfaceComponent } from '@app/interfaces/interface.component';
export { NgSelectOptionInterface } from '@app/interfaces/ng-select-option.interface';
export { DatepickerOptionsInterface } from './datetimepicker-options.interface';
export { ActiveRoute } from './active-route';